export default defineNuxtRouteMiddleware((from,to) => {
    const backendStore = useBackendStore();
    const isEmbedState = useState('isEmbed', () => false);

    const { hostname } = useRequestURL();

    if(hostname.split(".")[0] === 'embed') {
      backendStore.setIsEmbed(true)
      const cookie = useCookie('embed_client_token', { path: '/' })
      const tokenFromQuery = to.query.embed_client_token

      if (tokenFromQuery) {
        cookie.value = tokenFromQuery
      }
      
    } else {
      backendStore.setIsEmbed(false);
      isEmbedState.value = false;
    }
  });
